<template>
  <div class="english-container">
    <h2>Product Overview</h2>
    <p  style="text-align: left;" >We share your excitement about Wireless tag for Android trackers that are designed to seamlessly integrate with Google'sFind Hub app and help you track your items with the help of billions of Android devices worldwide
</p>
  
    <p  style="text-align: left;" >Wireless tag is a smart tracker device that uses Google Find Hub service, paired with the “ Find Hub” app on Android devices, to quickly and securely locate your personal items on Google Maps All location information remains private, and even Google cannot access it.
</p>

<h3> 1. Log in Find Hub APP</h3>
  <ol>
    <li>Go to Google Play and search for 'Find Hub.</li>
    <li>Install the app or click to "Update'.</li>
    <li> Hit 'Open' or click on the Find Hub app icon on your phone home page</li>
    <li>Log in to the Find Hub page with your Google account.You might want to select the checkbox that says Don't ask again'
lf you have more than one account, your item will link to the primary account setup on your phone.</li>
    <li>You might be asked to allow some permissions. Review theterms and continue
</li>
  </ol>

  <h3>2. Power On</h3>
  <p style="text-align: left;">
    <strong> Power On: </strong> Hold the circular dot on the devices power button for 3 seconds, and when you hear a ring-ring chime, it indicates that the device has been powered on.(Refer to the diagram)
  </p>

   <img src="../assets/gid_1.png" alt="Wireless Tag Logo" class="image_1" />

<h3>3. Connect to Find Hub app</h3>
  
      <p style="text-align: left;">
        3.1 Make sure your phone's Bluetooth is ON and you are connected to the internet.
      </p>
 <p style="text-align: left;">
  3.2 Bring your tag close to your phone and wait for the pop-up to show Wireless tag, on the pop up bottom sheet, hit 'Connect Read and accept the prompts to complete the pairing
</p>

<h3>4.Product introduction</h3>
<h4>4.1 Nearby Finding</h4>
<p style="text-align: left;">
  4.1.1 You're sometimes closer to your lost item than you may think. lf you know that it's some where in the house, Find Hub will indicate its signal strength so you can narrow down its location
</p>
<p style="text-align: left;">
  4.1.2 If your device is within wireless signal range , select your device in the“Find Hub app and tap “Play Sound”to locate your device. Once found, tap“Stop Sound”to silence the device.
</p>
<p style="text-align: left;">
  4.1.3 Google Assistant on your Google Home or Pixel Watch is here to help. Try prompts such as,“Hey Google, find my wallet or “Hey Google, find my keys” to quickly find your things.

</p>
<h4>4.2 A community for finding</h4>
  <p style="text-align: left;">
   For the moments when you're really far away from an item, the Find Hub network is here to help. Android devices all over theworld - like tablets, phones, and laptops - will work together to support you in finding your lost items.
</p>
<h4>4.3 Enable Lost Mode</h4>
 <p style="text-align: left;">
  When your item is lost, select the device in the “Find Hub appand tap“Mark as lost”. You will receive a notification when location becomes available. You can leave your contact information for the finder of your item to contact you.
  </p>

  <h4>4.4 Location Sharing</h4>

   <p style="text-align: left;">
Select the device in the “Find Hub” app, then tap “Share Device”. After the accessory owner confirms sharing - the accessory will be visible on the list in Find Hub app. Both accounts will see the location updates and may ring the device locally.
  </p>

  <h4>4.5 Unknown tracker alerts</h4>
   <p style="text-align: left;">
Your safety comes first. Find Hub is built to deter unwanted tracking. lf your Android phone notices an unfamiliar device moving with you, youll receive a notification.View the unknown device on a map, ring it to find it by sound, or get further help.
  </p>

  <h4>4.6 Privacy</h4>
   <p style="text-align: left;">
Your location data is end-to-ena encrypted, meaning that Google can never view or access it. Only you can see where your items have been and currently are. With the Find Hub app,Google does not use nor share your data. The information you share about yourself and your devices remains confidential.
  </p>
  
 <h3>5. Battery replacement</h3>
  <p style="text-align: left;">
      5.1 Insert the shell opening with a shell opening tool.
  </p>

   <p style="text-align: left;">
      5.2 Rotate the shell opening tool 90 degrees to open the shell.
  </p>

   <p style="text-align: left;">
      5.3 Use your fingernails at the small gap on the side of your ltem Locater to carefully open the case.
  </p>

   <p style="text-align: left;">
      5.4 Replace the battery with a new CR2032 battery 3V (Positive pole with the text upward).
  </p>

     <img src="../assets/open_tag.png" alt="Wireless Tag Logo" class="image_1" />

  <h3>6. Button function</h3>
  <ol>
    <li style="text-align: left;">
      Power on (Find my function is on)
      <p>
        Press the function button 3 seconds to turn it on. it should aring-ring chime indicating it is powered on.lf the product is not linked with your Google account, it will be closed within 10 minutes automatically. You need to trigger the find my function again to continue pairing.
        </p>
    </li>
    <li style="text-align: left;">Power off (Find my function is off).
      <p>
        Hold the function button for three seconds then <strong>release it...</strong> you will hear two beeps indicating it is powered off.
      </p>
    </li>
    <strong  style="text-align: left;">
      <p>Remark:</p>
      <p>1. lf you press it for less than 3 seconds or more than 5 seconds, The device won't shut down</p>
      <p>2. Setting a shutdown timer are designed to prevent accidental shutdowns, ensuring the device can continue to locate effectively</p>
    </strong>

    <li style="text-align: left;">Restore factory settings</li>
    <p style="text-align: left;"> 
      Press the function button two times, you can hear one beep then press the function button four times rapidly and then hold it a fifth time until you hear a ring-ring chime, now the device is reset.
    </p>
  </ol>

  <h3>  FAQ  </h3>
  <h4>Can't Connect My Device With Google's Find My Device App
The following action is recommended:  </h4>
<ol>
  <li style="text-align: left;">Restart your phone’s Bluetooth and cellular network.
Restart your phone’s Bluetooth and cellular network, shut down and restart the device, then wait for the pop-up to show “Wireless tag”.
</li>
  <li style="text-align: left;">Reset your device.Reset your device, shut down and restart the device. Then wait for the pop-up to show “Wireless tag”.
</li>
  <li style="text-align: left;">Please restart your phone and try again.
Please restart your phone, shut down and restart the device, then wait for the pop-up to show “Wireless tag”.
</li>
<li style="text-align: left;"> Update your phone’s software.
  <p>
    Step 1.Access phone settings and find “System”</p>
<p>Step 2. Find Software updates and open “System update”, then check for update.</p>
<p>Step 3. Update your phone’s system to newest system.</p>
</li>
<li style="text-align: left;">Find your phone’s Google service to connect the device.
  <p>Step 1.Access phone settings and find “Google service&perferences”.</p>
<p>Step 2. Access“Google service&perferences” and find “All services”.</p>
<p>Step 3. Access“All services” and find “Connected devices &Sharing”.</p>
<p>Step 4. Access“Devices” and find “Available devices nearby”. If you can see “Wireless tag”, click the “wireless tag”,then wait for the pop-up to show “Wireless tag”.</p>
<p>Step 5. If you can not see “Wireless tag”, you need shut down and restart the device, until you see the “Wireless tag”. Or reset your device, shut down and restart the device, until you see the “Wireless tag”. Then click the “wireless tag”,then wait for the pop-up to show “Wireless tag” and tab it to connect.</p>
</li>
</ol>
<p style="text-align: left; color:#333 "  >Once linked to a Google account, the device becomes inaccessible to other users.</p>
<p style="text-align: left; color:#333 "  >When your item is nearby, you can remove item in the app, it should make a ring-ring chime indicating it is removed successfully, then the item can be used by other people .</p>
<p style="text-align: left; color:#333 "  >When your item is out of the range of your phone’s connection, and your Locator is removed from Find My app, the device can’t be used by other people. you need reset your locator, then it can be used by other people.</p>

<h3>WARNING</h3>
<ol>
  <li> Remove and Immediately recycle or dispose of used batteries according to local regulations and keep away from children.Do NOT dispose of batteries in household trash or incinerate.</li>
  <li>Even used batteries may cause severe injury or death.</li>
  <li>Call a local poison control center for treatment information.</li>
  <li>Non-rechargeable batteries are not to be recharged.</li>
  <li>Do not force discharge, recharge, disassemble, heat above 50°C/122°F or incinerate.</li>
  <li>Doing so may result in injury due to venting, leakage or explosion resulting in chemical burns.6. The compatible battery type is CR2032.</li>
  <li>The nominal battery voltage: DC 3V</li>
  <li>Ensure the batteries are installed correctly according to polarity(+ and -). 9. Do not mix old and new batteries, different brands or types of batteries, such as alkaline, carbon-zinc, or rechargeable batteries.</li>
  <li>Remove and immediately recycle or dispose of batteries from equipment not used for an extended period of time according to local regulations.</li>
  <li> Always completely secure the battery compartment. If the battery compartment does not close securely, stop using the product, remove the batteries,and keep them away from children.</li>
</ol>
<h5>
  <p>Battery type: CR2032. Battery voltage: 3V.</p>
<p>Keep in original package until ready to use;</p>
<p>Immediately dispose of used batteries and keep away from children. Do NOT dispose of batteries in household trash.</p>
</h5>

<img src="../assets/image_battery.png" class="image_1">

</div>

</template>

<script>
export default {
  name: 'EnglishLuage',
};
</script>

<style scoped>
.english-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1, h2,h3,h4,h5 {
  color: #333;
 text-align: left; /* 明确标题左对齐（如果父级未继承） */

}
ul, ol {
  margin-left: 20px;
  padding-left: 15px;
 list-style-type: decimal; /* 强制显示数字编号 */

}
li {
  margin-bottom: 8px;
  text-align: left;
  color: #000000;
}

.image_1 {
  width: 90%; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}

</style>